import React from 'react'
import PropTypes from 'prop-types'
import { Button, Card } from 'antd'
import Webcam from './Webcam'
import FaceRect from './FaceRect'

const WebcamPanel = props => (
  <Card>
    <div style={{ overflow: 'hidden' }}>
      <div style={{ display: 'inline-block', position: 'relative', textAlign: 'center' }}>
        {!props.captured && (
          <Webcam
            onCapture={props.handleWebcam}
            interval={props.interval}
            width={640}
            height={480}
          />
        )}
        {props.captured && <img src={props.previewImage} alt="preview" style={{ marginBottom: '5px' }} />}
        {props.faces.map(({ faceId, faceRectangle }, index) => (
          <FaceRect key={faceId} label={`#${index + 1}`} faceId={faceId} {...faceRectangle} />
        ))}
        <div>
          {!props.captured && <Button type="primary" size="large" onClick={props.handleCapture}>Capture</Button>}
          {props.captured && <Button type="danger" size="large" onClick={props.handleReCapture}>Re capture</Button>}
        </div>
      </div>
    </div>
  </Card>
)
WebcamPanel.propTypes = {
  captured: PropTypes.bool.isRequired,
  faces: PropTypes.arrayOf(PropTypes.any),
  previewImage: PropTypes.string.isRequired,
  handleWebcam: PropTypes.func.isRequired,
  handleCapture: PropTypes.func.isRequired,
  handleReCapture: PropTypes.func.isRequired,
  interval: PropTypes.number,
}
WebcamPanel.defaultProps = {
  faces: [],
  interval: 800,
}

export default WebcamPanel



// WEBPACK FOOTER //
// ./src/components/WebcamPanel.js